import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axios";

const initialState = {
  categories: [],
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL: "https://nodeapp.shrinkcom.com/kwacharides-backend",
  // baseURL: "http://192.168.0.239:6010",

  favUnFavDetail: {},
  favUnFavStatus: "loading",
  getFavcarsData: [],
  carModals: [],
};

const config = {
  headers: {
    key: "KwachaRides-api-secret-key",
  },
};

export const getCategories = createAsyncThunk("getCategories", async () => {
  try {
    const response = await axios.get(`/category/getCategories`, config);
    return response?.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const favUnfav = createAsyncThunk("favUnfav", async (info) => {
  try {
    const response = await axios.post(
      `/favourite/favUnfav`,
      { signInId: info?.signInId, carId: info?.carId },
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data?.errors;
  }
});

export const getFavcars = createAsyncThunk("getFavcars", async (info) => {
  try {
    const response = await axios.get(
      `/favourite/getFavcars?signInId=${info?.signInId}`,
      config
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data?.errors;
  }
});
export const fetchCarModal = createAsyncThunk("fetchCarModal", async (info) => {
  try {
    const response = await axios.get(`/car/fetchCarModel`, config);
    return response?.data;
  } catch (error) {
    return error.response?.data?.errors;
  }
});

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    cleanFavUnfav(state) {
      state.favUnFavDetail = {};
      state.favUnFavStatus = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.fulfilled, (state, action) => {
        state.categories = action?.payload?.data;

        state.categories = action.payload.data;
      })
      .addCase(favUnfav.pending, (state, action) => {
        state.favUnFavStatus = "pending";
      })
      .addCase(favUnfav.fulfilled, (state, action) => {
        state.favUnFavDetail = action?.payload;
        state.favUnFavStatus = "fulfilled";
      })
      .addCase(favUnfav.rejected, (state, action) => {
        state.favUnFavStatus = "loading";
      })
      .addCase(getFavcars.fulfilled, (state, action) => {
        state.getFavcarsData = action?.payload?.data;
      })
      .addCase(fetchCarModal.fulfilled, (state, action) => {
        state.carModals = action?.payload?.data;
      });
  },
});

export const { cleanFavUnfav } = configSlice.actions;
export default configSlice.reducer;
